import { CatalogItemsAPI } from "../ApiStore/apiStore";

const ONFAVORIT = "ONFAVORIT-AC";
const OFFFAVORIT = "OFFFAVORIT-AC";
const SET_CURRENT_PAGE = "SET-CURRENT-PAGE";
const SET_CATOLOG_ITEMS = "SET-CATOLOG-ITEMS";
const GET_CATOLOG_ITEMS = "gET-CATOLOG-ITEMS";
const SET_TOTAL_PAGE = "SET-TOTAL-PAGE";
const SET_TOTAL_FISH = "SET_-TOTAL-FISH";
const SET_BASKET_ITEMS = "SET-BASKET-ITEMS";
const SET_BASKET_ITEMS_CANBAY = "SET-BASKET-ITEMS-CANBAY";
const TOGGLE_IS_DISPETCHER_ITEMS = "TOGGLE-IS-DISPETCHER-ITEMS";
const TOGGLE_IS_DISPETCHER_ITEMS_MOBY = "TOGGLE-IS-DISPETCHER-ITEMS-MOBY"

let initialState = {
    catologItems: [],
    pageSize: 48,
    totalItemsCount: 100,
    currentPage: 1,
    countwh: 0,
    isFetchingItems: true,
    isFetchingItemsMoby: true,
    basketIdItems: [],
    arBasketItemsCanBuy: []

}

const catologItemsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CATOLOG_ITEMS: {

            return {
                ...state,
                catologItems: action.catologItem
            }
        }
        case SET_CATOLOG_ITEMS: {

            return {
                ...state,
                catologItems: action.catologItem
            }
        }
        case SET_CURRENT_PAGE: {

            return {
                ...state,
                currentPage: action.currentPage
            }
        }
        case SET_TOTAL_FISH: {

            return {
                ...state,
                countwh: action.countwh
            }
        }
        case SET_BASKET_ITEMS: {

            return {
                ...state,
                basketIdItems: action.basketIdItems
            }
        }
        case SET_BASKET_ITEMS_CANBAY: {

            return {
                ...state,
                arBasketItemsCanBuy: action.arBasketItemsCanBuy
            }
        }
        case TOGGLE_IS_DISPETCHER_ITEMS: {

            return {
                ...state,
                isFetchingItems: action.isFetchingItems
            }
        }
        case TOGGLE_IS_DISPETCHER_ITEMS_MOBY: {

            return {
                ...state,
                isFetchingItemsMoby: action.isFetchingItemsMoby
            }
        }
        default: {
            return state;
        }
    }
}



export const setcatologItemsAC = (catologItem) => {

    return {
        type: SET_CATOLOG_ITEMS, catologItem
    }
}
export const settoggleDispetcherItems = (isFetchingItems) => {
    return {
        type: TOGGLE_IS_DISPETCHER_ITEMS, isFetchingItems
    }
}
export const settoggleDispetcherItemsMoby = (isFetchingItemsMoby) => {
    return {
        type: TOGGLE_IS_DISPETCHER_ITEMS_MOBY, isFetchingItemsMoby
    }
}
 
export const setCurrentPage = (currentPage) => {
    return {
        type: SET_CURRENT_PAGE, currentPage
    }
}
export const settotalUsersCountAC = (totalItemsCount) => {
    return {
        type: SET_TOTAL_PAGE, count: totalItemsCount
    }
}

export const setcatologItemsFish = (countwh) => {
    return {
        type: SET_TOTAL_FISH, countwh
    }
}

export const setBasketIdItemsFish = (basketIdItems) => {
    return {
        type: SET_BASKET_ITEMS, basketIdItems
    }
}
export const setBasketIdItemsCanBuy = (arBasketItemsCanBuy) => {
    return {
        type: SET_BASKET_ITEMS_CANBAY, arBasketItemsCanBuy
    }
}

export const getCatalogItems = (pageSize, currentPage, filtr = "") =>

    async (dispatch) => {
        dispatch(settoggleDispetcherItems(true));
        let data = await CatalogItemsAPI.CatalogItems(pageSize, currentPage, filtr);



        dispatch(setcatologItemsAC(data.items));
        dispatch(settoggleDispetcherItems(false));

    }

    export const getCatalogItemsMoby = (pageSize, currentPage, filtr = "") =>

    async (dispatch) => {
        dispatch(settoggleDispetcherItemsMoby(true));
        let data = await CatalogItemsAPI.CatalogItems(pageSize, currentPage, filtr);
        dispatch(setcatologItemsAC(data.items));
        dispatch(settoggleDispetcherItemsMoby(false));

    }
    export const getCatalogItemsFish = (p_id,pp_id,price,name,url,patchImgValue) =>

    async (dispatch) => {
        dispatch(settoggleDispetcherItems(true));
        let data = await CatalogItemsAPI.CatalogItemsFish(p_id,pp_id,price,name,url,patchImgValue);
        dispatch(setcatologItemsFish(data.countwh));
        dispatch(setBasketIdItemsFish(data.basketIdItems));
        dispatch(settoggleDispetcherItems(false));


    }

    export const getBasketIdItemsFish = (getBasket=true) =>

    async (dispatch) => {
        dispatch(settoggleDispetcherItems(true));
        let data = await CatalogItemsAPI.BasketIdItemsFish(getBasket);
        dispatch(setBasketIdItemsFish(data.basketIdItems));
        dispatch(setBasketIdItemsCanBuy(data.arBasketItemsCanBuy));
        dispatch(setcatologItemsFish(data.countwh));
        dispatch(settoggleDispetcherItems(false));

    }


export default catologItemsReducer;